import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Partner, partnerService } from '../services/partnerService';
import '../css/standard-components.css';

const AddPartner: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');
  const { user } = useAuth();
  const [isEdit, setIsEdit] = useState(false);
  const [isView, setIsView] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: ''
  });

  useEffect(() => {
    const path = window.location.pathname;
    if (path.includes('/view/')) {
      setIsView(true);
    } else if (path.includes('/edit/')) {
      setIsEdit(true);
    }

    if (id && (isEdit || isView)) {
      loadPartner();
    }
  }, [id, isEdit, isView]);

  const loadPartner = async () => {
    try {
      setLoading(true);
      const partner = await partnerService.getPartner(parseInt(id!));
      setFormData({
        name: partner.name
      });
    } catch (error) {
      console.error('Error loading partner:', error);
      alert('Error loading partner');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isView) return;

    try {
      setLoading(true);
      
      if (isEdit) {
        await partnerService.updatePartner(parseInt(id!), { name: formData.name });
        alert('Partner updated successfully!');
      } else {
        await partnerService.createPartner({ name: formData.name });
        alert('Partner created successfully!');
      }
      
      navigate('/partners');
    } catch (error) {
      console.error('Error saving partner:', error);
      alert('Error saving partner');
    } finally {
      setLoading(false);
    }
  };

  const getPageTitle = () => {
    if (isView) return 'View Partner';
    if (isEdit) return 'Edit Partner';
    return 'Add Partner';
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>{getPageTitle()}</h1>
        <button 
          className="btn btn-secondary"
          onClick={() => navigate('/partners')}
        >
          Back to Partners
        </button>
      </div>

      <div className="form-container">
        <form onSubmit={handleSubmit} className="standard-form">
          <div className="form-grid">
            <div className="form-group">
              <label htmlFor="name">Partner Name *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                required
                disabled={isView}
                className="form-input"
              />
            </div>
          </div>

          <div className="form-actions">
            <button
              type="button"
              onClick={() => navigate('/partners')}
              className="btn btn-secondary"
            >
              Cancel
            </button>
            {!isView && (
              <button
                type="submit"
                disabled={loading}
                className="btn btn-primary"
              >
                {loading ? 'Saving...' : (isEdit ? 'Update Partner' : 'Create Partner')}
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddPartner;
